<template>
  <div class="c-puzzle puzzle">
    <div class="puzzle__mask">
      <div class="puzzle__container">
        <PuzzleItem
          v-for="index in 16"
          :key="index"
          :data-index="index"
          :illustration="illustration"
          :inGame="inGame"
          :isLast="index === 16"
        >{{ index }}</PuzzleItem>
      </div>

      <div
        class="puzzle__full-art"
        :class="{ hidden: !showFullArt }"
        :style="{ backgroundImage: `url('${illustration}')` }"
      ></div>
    </div>
  </div>
</template>

<script>
import PuzzleItem from '@/components/PuzzleItem.vue';

export default {
  name: 'Puzzle',

  components: {
    PuzzleItem,
  },

  props: {
    inGame: {
      type: Boolean,
      required: true,
    },
    illustration: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      showFullArt: false,
    };
  },

  mounted() {
    this.$root.$on('show-full-art', () => { this.showFullArt = true; });
    this.$root.$on('hide-full-art', () => { this.showFullArt = false; });
  },
};
</script>

<style lang="scss" scoped>
.puzzle {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 10px;

  @at-root .grabbable & {
    cursor: grab;

    &:active {
      cursor: grabbing;
    }
  }

  &[data-color="beige"] {
    background-color: #FEEDD9;
  }
  &[data-color="azure"] {
    background-color: #45A3B2;
  }
  &[data-color="blue"] {
    background-color: #3D6389;
  }
  &[data-color="pink"] {
    background-color: #D09EC1;
  }

  &__mask {
    position: relative;
    width: 100%;

    background-color: $color-beige;
    overflow: hidden;

    @include aspect-ratio(1, 1);
  }

  &__container {
    position: absolute;
    top: 50%;
    left: 50%;
    width: calc(100% + 4px);

    transform: translateX(-50%) translateY(-50%);

    @include aspect-ratio(1, 1);
  }

  &__full-art {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;

    background-position: center center;
    background-size: cover;

    pointer-events: none;
    z-index: 9;
    opacity: 1;
    transition: opacity .6s ease;

    &.hidden {
      opacity: 0;
    }
  }
}
</style>
